<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>Assign Gps Device To Ship</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">Assign Gps Device To Ship</ion-title>
        </ion-toolbar>
      </ion-header>

      <div id="container">
        <ion-item>
            <ion-label position="floating">Ship <span class="required">*</span></ion-label>
            <ion-select mode="ios" interface="action-sheet" @IonChange="shipChanged" v-model="postData['ship_id']">
                <ion-select-option v-for="(ship,i) of ships" :key="i" :value="ship.id"><strong>{{ship.ship_name}}</strong>, {{ship.owner.client_name}}, {{ship.owner.company.company_name}}</ion-select-option>
            </ion-select>
        </ion-item>
        <Dropdown @change="gpsDeviceChanged" v-model="gpsDevice" :options="gpsDevices" optionLabel="name" :required="true" dataKey="value" placeholder="GPS Device" :filter="true" filterPlaceholder="GPS Device" />

        <!-- Phase 4: pairing during a service = the device is replaced. Free or charged is a decision, not automatic. -->
        <div v-if="service" class="service-box">
          <div class="service-title">Service #{{ service.service_requisition_id }} · {{ service.problem }}</div>
          <div class="warranty" :class="'warranty-' + (service.warranty ? service.warranty.state : 'none')">Warranty: {{ service.warranty ? service.warranty.text : 'no warranty on record' }}</div>
          <div class="service-summary">Current decision: {{ service.summary }}</div>
          <ion-item>
              <ion-label position="floating">Replacement device</ion-label>
              <ion-select mode="ios" interface="action-sheet" v-model="postData['replacement_decision']">
                  <ion-select-option value="">Leave to the office</ion-select-option>
                  <ion-select-option value="Free">Free</ion-select-option>
                  <ion-select-option value="Charged">Charged</ion-select-option>
              </ion-select>
          </ion-item>
          <ion-item v-if="postData['replacement_decision'] === 'Charged'">
              <ion-label position="floating">Amount (Tk)<span v-if="service.suggested && service.suggested.replacement"> · suggestion {{ service.suggested.replacement }}</span></ion-label>
              <ion-input mode="ios" type="number" inputmode="decimal" v-model="postData['replacement_amount']"></ion-input>
          </ion-item>
        </div>

        <ion-button expand="block" @click="save()" color="primary">Save</ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script >
import { IonButtons, IonButton, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonItem, IonLabel,IonSelect,IonSelectOption,IonInput,alertController } from '@ionic/vue';
import Loading from '../Loading';
import Dropdown from './modules/Dropdown.vue';
export default {
  name: 'Create Service Requisition',
  data(){
    return {
    companies:[],
    company:'',
    gpsDevices:[],
    gpsDevice:'',
    clients:[],
    ships:[],
    service:null,
    postData:{
        'ship_id':null,
        'gps_device_id':null,
        'replacement_decision':'',
        'replacement_amount':'',
    }
    }
  },
  created(){
    this.loadData();
  },
  methods:{
      async presentResponseAlert(type,message) {
      const alert = await alertController
        .create({
          header: type+'!',
          // subHeader: 'Subtitle',
          message: message,
          buttons: ['OK'],
        });
      await alert.present();

    },
    async loadData(){
      this.postData['ship_id']=null;
      this.service=null;
      this.$http.get('myAssignableShips',{params:
      {
        'username':window.localStorage.username,
        'password':window.localStorage.password
      }
      }).then(response=>{
          this.ships=response.data;
      });
      this.$http.post('myAssignableGpsDevices',
      {
        'username':window.localStorage.username,
        'password':window.localStorage.password
      }
      ).then(response=>{
        this.gpsDevices=[];
        for(const gpsDevice of response.data ){
          this.gpsDevices.push({
            name:gpsDevice.serial,
            value:gpsDevice.id
          });
        }
        // this.gpsDevices=response.data;
      });
    },
    // A ship with a service in progress: show its billing state and ask about the replacement.
    shipChanged(){
      const ship=this.ships.find(s=>s.id===this.postData['ship_id']);
      this.service=ship && ship.service_billing ? ship.service_billing : null;
      this.postData['replacement_decision']='';
      this.postData['replacement_amount']='';
    },
    async save(){
        const requireds=[
            'ship_id',
            'gps_device_id',
        ];
        for(const required of requireds){
            if(this.postData[required]=='' || this.postData[required]==null){
                let name=required;
                name=name.replace('_id','');
                name=name.replace('_',' ');
                this.presentAlert(name);
                return;
            }
        }
        if(this.postData['replacement_decision']==='Charged' && !(Number(this.postData['replacement_amount'])>0)){
          this.presentResponseAlert('Alert','Give the amount for the charged replacement device.');
          return;
        }
        const data=this.postData;
        data['username'] = window.localStorage.username,
        data['password'] = window.localStorage.password,
      this.$http.post('assignGpsDeviceToShip',data).then(response=>{
        if(response.status==200){
            const billing = response.data && response.data.service_billing ? '\nService billing: ' + response.data.service_billing : '';
            this.postData={
                'ship_id':null,
                'gps_device_id':null,
                'replacement_decision':'',
                'replacement_amount':'',
            }
        this.company=null;
        this.gpsDevice=null;
          this.presentResponseAlert('Success','Device paired successfully' + billing);
          this.loadData();
        }
      }).catch(error=>{
        const message = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Could not pair the device.';
        this.presentResponseAlert('Error', message);
      });
    },
    async presentAlert(message) {
      const alert = await alertController
        .create({
          header: 'Alert!',
          // subHeader: 'Subtitle',
          message: message+" is required",
          buttons: ['OK'],
        });
      await alert.present();

    },
    gpsDeviceChanged(){
        this.postData['gps_device_id']=this.gpsDevice.value;
    },
  },
  components: {
    IonButtons,
    IonButton,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    IonItem,
    IonLabel,
    IonSelect,
    IonSelectOption,
    IonInput,
    Dropdown
  }

}
</script>

<style scoped>
#container {
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  /* top: 50%; */
  /* transform: translateY(-50%); */
}

#container strong {
  font-size: 20px;
  line-height: 26px;
}

#container p {
  font-size: 16px;
  line-height: 22px;
  color: #8c8c8c;
  margin: 0;
}

#container a {
  text-decoration: none;
}
.p-dropdown{
width: 100%;
color:#000;
}
.required{
  color:rgb(233, 0, 0)
}
.service-box{
  margin: 12px 8px;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  text-align: left;
}
.service-title{
  font-weight: 600;
}
.service-summary{
  font-size: 12px;
  color: #555;
  margin: 4px 0;
}
.warranty{
  font-size: 13px;
  padding: 4px 8px;
  border-radius: 4px;
  background: #f2f2f2;
  margin-top: 4px;
}
.warranty-active{ background: #e6f7e6; color: #1b7a1b; }
.warranty-expired, .warranty-void{ background: #fdeaea; color: #a81818; }
.warranty-none{ background: #fff6e0; color: #8a5a00; }
</style>
